<div *ngIf="!isProductionEnvrionment" class="container">
  <div class="container-poster"></div>
  <div class="container-main">
    <div class="containerMain-header">
      <h1 class="mainHeader-title">Quality Management System</h1>
      <p class="mainHeader-description">A few more clicks to sign in to your account.</p>
    </div>
    <form action="" class="containerMain-form">

      <button class="mainForm-btnLogin" (click)="getParamsToURL()">Click Login</button>
    </form>
  </div>
  <div class="container-poster"></div>
</div>

<div *ngIf="isProductionEnvrionment && IsDirectLogin" class="loader-img">
<div id="container">
  <div id="one"></div>
  <div id="two"></div>
</div>
</div>